import classNames from 'classnames'

import { commonIcons } from '@apps-common/config/icons'

interface IProps {
  bgClasses: string
  message?: string
  productId: string
  allowedProductIds: string[]
  children: any
}

export const ProductNotSupportedCard: React.FC<IProps> = ({ bgClasses, message, productId, allowedProductIds, children }) => {
  const allowed = allowedProductIds.includes(productId)

  return (
    <>
      {allowed && children}
      {!allowed && (
        <div className={classNames('max-w-[400px] min-h-[140px] rounded-[30px] px-5 py-4 flex items-center justify-center', bgClasses)}>
          <div className='flex flex-col items-center justify-center gap-[10px]'>
            <div className='bg-warning/50 ring-2 ring-warning p-3 rounded-2xl'>
              <commonIcons.toastWarning className='text-on-warning text-[2rem]' />
            </div>
            <p className='jost-light text-text text-center text-[0.9rem] sm:text-[1rem]'>{message || 'This product is not supported!'}</p>
          </div>
        </div>
      )}
    </>
  )
}
